import React from 'react'
import { useIntl } from 'react-intl'
import SearchBar from 'app/components/searchBar/SearchBar'
import FabButton from 'app/components/buttons/FabButton'
import { FuseAnimate } from '@fuse'

export default ({ isNoTopicCard, search, setIsOpenDialog }) => {
  const { formatMessage } = useIntl()

  return (
    <>
      {!isNoTopicCard && (
        <SearchBar
          className="ltr:mr-8 rtl:ml-8"
          searchFor={formatMessage({ id: 'notifications.topics.header.label' })}
          {...search}
        />
      )}

      <FuseAnimate animation="transition.expandIn" delay={300}>
        <FabButton
          title={formatMessage({
            id: 'notifications.topics.label',
          })}
          onClick={() => {
            setIsOpenDialog()
          }}
        >
          add
        </FabButton>
      </FuseAnimate>
    </>
  )
}
